import React, { useEffect, useState } from "react";
import { Box, Container, Paper, Stack, CircularProgress, Typography } from "@mui/material";
import StoresAppBar from "../routes/stores/StoresAppBar";
import GuestJoinBanner from "./GuestJoinBanner";
import GoogleAdSideRail from "./GoogleAdSideRail";
import GoogleAdInline from "./GoogleAdInline";
import PublicFooter from "./PublicFooter";
import { isLoggedIn } from "../session";
import { brandColors } from "../theme";
import { pageContentSx } from "../pageLayout";

// Hook para las páginas públicas: null mientras se resuelve la sesión.
export const useAuthUser = () => {
  const [state, setState] = useState({ checked: false, user: null });
  useEffect(() => {
    let active = true;
    isLoggedIn()
      .then((user) => active && setState({ checked: true, user }))
      .catch(() => active && setState({ checked: true, user: null }));
    return () => {
      active = false;
    };
  }, []);
  return state;
};

// Marco de las páginas que se ven sin iniciar sesión (detalle de ofertas y
// eventos, páginas institucionales). El anuncio lateral de AdSense se monta
// solo con `showAd` y cuando ya no está cargando: AdSense no permite
// anuncios en pantallas de carga, vacías o de "no encontrado".
//
// Si el lateral no entra, GoogleAdInline va al final del contenido; una
// página puede poner `inlineAd={false}` y ubicarlo ella misma.
const PublicPageLayout = ({ title, subtitle = "Notiline", loading, notFound, showAd = false, inlineAd = true, isGuest, children }) => (
  <Box sx={{ bgcolor: brandColors.backgroundDefault, minHeight: "100vh", pb: "80px" }}>
    <StoresAppBar title={title} subtitle={subtitle} quickNav={false} />
    <Container maxWidth={false} disableGutters sx={{ ...pageContentSx, pt: { xs: 4, md: 8 }, position: "relative" }}>
      {showAd && !loading && !notFound && <GoogleAdSideRail />}
      {isGuest && <GuestJoinBanner />}
      <Paper
        sx={{
          p: { xs: 2.5, sm: 4 },
          borderRadius: 4,
          backgroundColor: brandColors.backgroundPaper,
          border: `1px solid ${brandColors.divider}`,
        }}
      >
        {loading ? (
          <Stack alignItems="center" justifyContent="center" sx={{ minHeight: 240 }}>
            <CircularProgress />
          </Stack>
        ) : notFound ? (
          <Typography sx={{ color: "text.secondary" }}>{notFound}</Typography>
        ) : (
          children
        )}
      </Paper>
      {showAd && inlineAd && !loading && !notFound && <GoogleAdInline />}
      <PublicFooter />
    </Container>
  </Box>
);

export default PublicPageLayout;
